import * as constants from '../commons/constants';
import { isCi } from './isCiRun';
import { getLogger } from '../commons/logger';
import { writeStackTrace } from './writeStackTrace';
import { requireWithFallback } from '../commons/requireWithFallback';

const logger = getLogger('process-handler');

let exitCodeIgnoreFailingTests = false;

interface RunnerResult { runnerStatus?: string; success?: boolean; testStatus?: typeof constants['testStatus'][keyof typeof constants['testStatus']]; status?: string }

function getExitCode(result: Error | RunnerResult | number | undefined) {
    if (result instanceof Error) {
        return 1;
    }

    if (exitCodeIgnoreFailingTests) {
        return 0;
    }

    result ||= {};
    const hasFailedTests = Object.values(result).some(
        ({ runnerStatus, success, testStatus, status }) => {
            if (
                [runnerStatus, status].includes(constants.runnerTestStatus.SKIPPED) ||
                ([runnerStatus, status].includes(constants.runnerTestStatus.FAILED) &&
                    testStatus === constants.testStatus.EVALUATING)
            ) {
                return false;
            }
            return success !== true;
        },
    );

    return hasFailedTests ? 1 : 0;
}

function closeChromeDriverIfRunning() {
    try {
        const chromedriver = requireWithFallback('chromedriver');
        chromedriver.stop();
    } catch (err) { /* ignore */ }
}

export function ignoreFailingTestsInExitCode() {
    exitCodeIgnoreFailingTests = true;
}


export async function onExit(exitValue?: Error | RunnerResult | number) {
    if ((exitValue as any)?.stack) {
        if (!isCi) {
            writeStackTrace(exitValue as Error);
        } else {
            // eslint-disable-next-line no-console
            console.error(exitValue, (exitValue as any).stack);
        }
    }

    closeChromeDriverIfRunning();

    await logger.waitForFlush();

    process.exit(getExitCode(exitValue));
}
